const routes = [{
  path: '/workProgressManage',
  component: () => import('@/views/workProgressManage/index'),
  name: 'workProgressManage',
  meta: {
    title: '工单进度管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/setting/workProgressManage.js